import { createStore } from 'vuex';
//createApp.use(createStore);

const store = createStore({
    state () {
      return {
        
      }
    },
    getters : {
       
    },
    mutations: {
        
    }
});

export default store;